<template>
  <div class="card p-4">
    <h5 class="mb-4">{{ modo === "alta" ? "Nueva pasarela" : "Editar pasarela" }}</h5>

    <form @submit.prevent="handleSubmit">

      <!-- ── DATOS GENERALES ────────────────────────────── -->
      <div class="row g-3 mb-4">

        <!-- Tipster (solo admin puede elegir) -->
        <div class="col-md-6" v-if="esAdmin">
          <label class="form-label text-sm font-weight-bold">Tipster *</label>
          <select v-model="form.tipster_id" class="form-select" required @change="alCambiarTipster">
            <option value="">— Seleccionar tipster —</option>
            <option v-for="t in tipsteresEfectivos" :key="t.id" :value="Number(t.id)">{{ t.nombre }}</option>
          </select>
        </div>

        <!-- Nombre interno -->
        <div class="col-md-6">
          <label class="form-label text-sm font-weight-bold">Nombre interno *</label>
          <input v-model="form.nombre" type="text" class="form-control" maxlength="150" required placeholder="Mi pasarela VIP" />
        </div>

        <!-- Slug -->
        <div class="col-md-6">
          <label class="form-label text-sm font-weight-bold">Slug (URL pública) *</label>
          <div class="input-group">
            <input v-model="form.slug" type="text" class="form-control" maxlength="180" required placeholder="tipster-a8f3" />
            <button type="button" class="btn btn-outline-secondary mb-0" @click="generarSlug" :disabled="!form.tipster_id || cargandoSlug">
              {{ cargandoSlug ? "..." : "Sugerir" }}
            </button>
          </div>
          <small class="text-muted">Solo letras, números y guiones. Debe ser único.</small>
        </div>

        <!-- Idioma -->
        <div class="col-md-3">
          <label class="form-label text-sm font-weight-bold">Idioma</label>
          <select v-model="form.idioma" class="form-select">
            <option value="">Sin especificar</option>
            <option value="es">Español</option>
            <option value="en">English</option>
            <option value="pt">Português</option>
          </select>
        </div>

        <!-- Estado -->
        <div class="col-md-3">
          <label class="form-label text-sm font-weight-bold">Estado *</label>
          <select v-model="form.estado" class="form-select" required>
            <option value="borrador">Borrador</option>
            <option value="activa">Activa</option>
            <option value="inactiva">Inactiva</option>
          </select>
        </div>

        <!-- Título público -->
        <div class="col-12">
          <label class="form-label text-sm font-weight-bold">Título público</label>
          <input v-model="form.titulo" type="text" class="form-control" maxlength="180" placeholder="Servicios premium de mi tipster" />
        </div>

        <!-- Descripción -->
        <div class="col-12">
          <label class="form-label text-sm font-weight-bold">Descripción</label>
          <textarea v-model="form.descripcion" class="form-control" rows="3" placeholder="Descripción que verá el público en la pasarela..."></textarea>
        </div>

        <!-- Texto botón -->
        <div class="col-md-4">
          <label class="form-label text-sm font-weight-bold">Texto del botón de compra</label>
          <input v-model="form.texto_boton" type="text" class="form-control" maxlength="80" placeholder="Comprar ahora" />
        </div>

      </div>

      <!-- ── TEMA VISUAL ────────────────────────────────── -->
      <div class="mb-4">
        <label class="form-label text-sm font-weight-bold">Tema visual *</label>
        <PasarelaThemeSelector v-model="form.tema_visual" />
      </div>

      <!-- ── ARCHIVOS ────────────────────────────────────── -->
      <div class="row g-3 mb-4">
        <div class="col-md-6">
          <label class="form-label text-sm font-weight-bold">Logo</label>
          <input type="file" class="form-control" accept=".jpg,.jpeg,.png,.webp" @change="onLogo" />
          <small class="text-muted">JPG, PNG o WebP. Máx. 2 MB.</small>
          <div v-if="logoPreview || form.logo_url" class="mt-2">
            <img :src="logoPreview || urlArchivo(form.logo_url)" alt="Logo" style="height: 60px; object-fit: contain; border-radius: 6px; border: 1px solid #ddd;" />
            <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-2 mb-0" @click="quitarLogo">Quitar</button>
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label text-sm font-weight-bold">Banner (opcional)</label>
          <input type="file" class="form-control" accept=".jpg,.jpeg,.png,.webp" @change="onBanner" />
          <small class="text-muted">JPG, PNG o WebP. Máx. 3 MB.</small>
          <div v-if="bannerPreview || form.banner_url" class="mt-2">
            <img :src="bannerPreview || urlArchivo(form.banner_url)" alt="Banner" style="height: 60px; width: 100%; object-fit: cover; border-radius: 6px; border: 1px solid #ddd;" />
            <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-2 mb-0" @click="quitarBanner">Quitar</button>
          </div>
        </div>
      </div>

      <!-- ── PRODUCTOS ASIGNADOS ─────────────────────────── -->
      <div class="mb-4" v-if="form.tipster_id">
        <label class="form-label text-sm font-weight-bold">Productos asignados</label>
        <PasarelaProductosSelector
          v-model="form.productos"
          :productosDisponibles="productosDisponibles"
        />
      </div>
      <div v-else class="mb-4 text-sm text-muted">
        Selecciona un tipster para asignar productos.
      </div>

      <!-- ── ERROR / ACCIONES ───────────────────────────── -->
      <div v-if="error" class="alert alert-danger py-2 mb-3">{{ error }}</div>

      <div class="d-flex gap-2 justify-content-end">
        <button type="button" class="btn btn-secondary mb-0" @click="$emit('cancelar')">Cancelar</button>
        <button type="submit" class="btn btn-primary mb-0" :disabled="guardando">
          {{ guardando ? "Guardando..." : (modo === "alta" ? "Crear pasarela" : "Guardar cambios") }}
        </button>
      </div>

    </form>
  </div>
</template>

<script>
import PasarelaThemeSelector from "./PasarelaThemeSelector.vue";
import PasarelaProductosSelector from "./PasarelaProductosSelector.vue";
import {
  guardarPasarela,
  editarPasarela,
  productosDisponibles,
  slugSugerido,
} from "@/services/pasarelas.service.js";

export default {
  name: "PasarelaForm",
  components: { PasarelaThemeSelector, PasarelaProductosSelector },
  props: {
    modo: { type: String, default: "alta" },
    pasarela: { type: Object, default: null },
    tipsters: { type: Array, default: () => [] },
    tipsterIdFijo: { type: Number, default: null },
  },
  emits: ["guardada", "cancelar"],
  data() {
    return {
      form: {
        tipster_id: "",
        nombre: "",
        slug: "",
        idioma: "",
        titulo: "",
        descripcion: "",
        tema_visual: "azul_quanty",
        texto_boton: "Comprar ahora",
        estado: "borrador",
        logo_url: null,
        banner_url: null,
        productos: [],
      },
      logoFile: null,
      logoPreview: null,
      logoQuitado: false,
      bannerFile: null,
      bannerPreview: null,
      bannerQuitado: false,
      productosDisponibles: [],
      guardando: false,
      cargandoSlug: false,
      error: null,
      tipsteresLocales: [],
    };
  },
  computed: {
    esAdmin() {
      return this.$store.getters["auth/rolEfectivo"] === 1;
    },
    tipsteresEfectivos() {
      return this.tipsters.length > 0 ? this.tipsters : this.tipsteresLocales;
    },
  },
  async mounted() {
    if (this.esAdmin) {
      try {
        const data = await this.$store.dispatch("auth/listaTipsters");
        if (Array.isArray(data) && data.length > 0) {
          this.tipsteresLocales = data.map(t => ({ ...t, id: Number(t.id) }));
        }
      } catch (_) { /* sin acción */ }
    }
  },
  watch: {
    pasarela: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            tipster_id: val.tipster_id ? Number(val.tipster_id) : "",
            nombre: val.nombre ?? "",
            slug: val.slug ?? "",
            idioma: val.idioma ?? "",
            titulo: val.titulo ?? "",
            descripcion: val.descripcion ?? "",
            tema_visual: val.tema_visual ?? "azul_quanty",
            texto_boton: val.texto_boton ?? "Comprar ahora",
            estado: val.estado ?? "borrador",
            logo_url: val.logo_url ?? null,
            banner_url: val.banner_url ?? null,
            productos: (val.productos ?? []).map((p) => ({
              producto_id: p.id,
              nombre: p.nombre,
              precio: p.precio,
              orden: p.orden ?? 0,
              activo: p.activo ?? true,
              destacado: p.destacado ?? false,
            })),
          };
          if (val.tipster_id) this.cargarProductos(val.tipster_id);
        }
      },
    },
    tipsterIdFijo: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form.tipster_id = val;
          this.cargarProductos(val);
        }
      },
    },
  },
  methods: {
    async cargarProductos(tipsterId) {
      if (!tipsterId) return;
      try {
        const res = await productosDisponibles(tipsterId);
        this.productosDisponibles = res.data?.productos ?? [];
      } catch {
        this.productosDisponibles = [];
      }
    },

    async alCambiarTipster() {
      this.form.productos = [];
      await this.cargarProductos(this.form.tipster_id);
    },

    async generarSlug() {
      if (!this.form.tipster_id) return;
      this.cargandoSlug = true;
      try {
        const res = await slugSugerido(this.form.tipster_id);
        this.form.slug = res.data?.slug ?? "";
      } catch {
        // silencioso
      } finally {
        this.cargandoSlug = false;
      }
    },

    onLogo(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.logoFile = file;
      this.logoQuitado = false;
      const reader = new FileReader();
      reader.onload = (ev) => { this.logoPreview = ev.target.result; };
      reader.readAsDataURL(file);
    },

    quitarLogo() {
      this.logoFile = null;
      this.logoPreview = null;
      this.form.logo_url = null;
      this.logoQuitado = true;
    },

    onBanner(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.bannerFile = file;
      this.bannerQuitado = false;
      const reader = new FileReader();
      reader.onload = (ev) => { this.bannerPreview = ev.target.result; };
      reader.readAsDataURL(file);
    },

    quitarBanner() {
      this.bannerFile = null;
      this.bannerPreview = null;
      this.form.banner_url = null;
      this.bannerQuitado = true;
    },

    buildFormData() {
      const fd = new FormData();

      fd.append("tipster_id", this.form.tipster_id);
      fd.append("nombre", this.form.nombre);
      fd.append("slug", this.form.slug);
      fd.append("idioma", this.form.idioma ?? "");
      fd.append("titulo", this.form.titulo ?? "");
      fd.append("descripcion", this.form.descripcion ?? "");
      fd.append("tema_visual", this.form.tema_visual);
      fd.append("texto_boton", this.form.texto_boton || "Comprar ahora");
      fd.append("estado", this.form.estado);

      if (this.logoFile) {
        fd.append("logo", this.logoFile);
      } else if (this.logoQuitado) {
        fd.append("logo", "");
      }

      if (this.bannerFile) {
        fd.append("banner", this.bannerFile);
      } else if (this.bannerQuitado) {
        fd.append("banner", "");
      }

      this.form.productos.forEach((p, i) => {
        fd.append(`productos[${i}][producto_id]`, p.producto_id);
        fd.append(`productos[${i}][orden]`, p.orden ?? 0);
        fd.append(`productos[${i}][activo]`, p.activo ? 1 : 0);
        fd.append(`productos[${i}][destacado]`, p.destacado ? 1 : 0);
      });

      if (this.modo === "editar") {
        fd.append("id", this.pasarela.id);
      }

      return fd;
    },

    urlArchivo(url) {
      if (!url) return null;
      if (url.startsWith("http")) return url;
      return process.env.VUE_APP_API_BASE_URL + url;
    },

    async handleSubmit() {
      this.error = null;
      this.guardando = true;
      try {
        const fd = this.buildFormData();
        const fn = this.modo === "alta" ? guardarPasarela : editarPasarela;
        const res = await fn(fd);
        this.$emit("guardada", res.data?.pasarela);
      } catch (e) {
        this.error =
          e?.response?.data?.mensaje ||
          e?.response?.data?.message ||
          "Error al guardar la pasarela.";
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>

<style scoped>
select.form-select,
select.form-control {
  background-image: none !important;
  -webkit-appearance: menulist !important;
  -moz-appearance: menulist !important;
  appearance: menulist !important;
  padding-right: 0.75rem !important;
}
</style>
